export const getNow = () => Date.now();
